import getSource from 'helpers/candidate_attributes_generator';

const JOB_VIEW    = 'job_view';
const APPLY_START = 'apply_start';
const THANKS_VIEW = 'thanks_view';

const TP_SOURCE = 'tp_source';

// Helper functions ===============
function getTrackerId(source, campaignId) {
  return `tp_application_journey_${source}_CM${campaignId}`;
}

function getStoredTracker(trackerId) {
  const item = localStorage.getItem(trackerId);
  return item ? JSON.parse(item) : null;
}

function setStoredTracker(trackerId, data) {
  localStorage.setItem(trackerId, JSON.stringify(data));
}

function gtmPush(event, source, payload) {
  if (typeof window === 'undefined') {
    console.error('data-layer-push: window is undefined');
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, source: source.toLowerCase(), ...payload });
  console.info('data-layer-push', event, source.toLowerCase(), payload);
}
// ================================

export function setSource() {
  const params = new URLSearchParams(window.location.search);
  const src = getSource(params);

  localStorage.setItem(TP_SOURCE, src.toLowerCase());

  return src;
}

export default function applicationJourneyGtm(campaignId) {
  if (typeof window === 'undefined') {
    console.error('data-layer-push: window is undefined');
    return {};
  }

  const src = localStorage.getItem(TP_SOURCE);
  const trackerId = getTrackerId(src, campaignId);
  const sourceLower = src ? src.toLowerCase() : '';
  const gtmData     = { jobId: `${campaignId}` };

  function jobView() {
    console.log('gtm-job-view', trackerId, sourceLower, gtmData);
    try {
      // let gtmTrack = getStoredTracker(trackerId);

      // if (gtmTrack && (gtmTrack.apply_start || gtmTrack.appId)) {
      //   localStorage.removeItem(trackerId);
      //   gtmTrack = null;
      // }

      // if (!gtmTrack) {
        setStoredTracker(trackerId, {
          appId:       '',
          job_view:    true,
          apply_start: false,
          thanks_view: false,
        });
        gtmPush(JOB_VIEW, sourceLower, gtmData);
      // }
    } catch (e) {
      console.error('data-layer-push', e);
    }
  }

  function applyStart() {
    console.log('gtm-apply-start', trackerId, sourceLower, gtmData);
    try {
      // const gtmTrack = getStoredTracker(trackerId);

      // if (gtmTrack && !gtmTrack.apply_start) {
        setStoredTracker(trackerId, {
          appId:       '',
          job_view:    true,
          apply_start: true,
          thanks_view: false,
        });
        gtmPush(APPLY_START, sourceLower, gtmData);
      // }
    } catch (e) {
      console.error('data-layer-push', e);
    }
  }

  function thanksView(applicantId) {
    console.log('gtm-thanks-view', trackerId, sourceLower, gtmData);
    try {
      // const gtmTrack = getStoredTracker(trackerId);

      // if (gtmTrack
      //     && gtmTrack.apply_start
      //     && !gtmTrack.thanks_view
      //     && gtmTrack.appId === applicantId
      //   ) {
        gtmPush(THANKS_VIEW, sourceLower, gtmData);
        localStorage.removeItem(trackerId);
      // }
    } catch (e) {
      console.error('data-layer-push', e);
    }
  }

  function setAppId(applicantId) {
    try {
      const gtmTrack = getStoredTracker(trackerId);
      setStoredTracker(trackerId, {
        appId:       applicantId,
        job_view:    gtmTrack.job_view,
        apply_start: gtmTrack.apply_start,
        thanks_view: gtmTrack.thanks_view,
      });
    } catch (e) {
      console.error('set-app-id', e);
    }
  }

  return {
    jobView,
    applyStart,
    thanksView,
    setAppId,
  };
}